import { Box } from '@zillow/constellation-10';

import OptimizeForScopeCard from './OptimizeForScopeCard';

export function AutoSpotlightPanel() {
  return (
    <Box data-testid="auto-spotlight-panel">
      <OptimizeForScopeCard />
    </Box>
  );
}

export default AutoSpotlightPanel;
